import { getQueryLocale } from '../../common/selectors/locale-selectors';
import { handleTagCloudWidgetResponse } from '../aggregated-tag-cloud/actions';

export const fetchTagCloudWidgetInitialData =
  () =>
  async (dispatch, getState, { aggregatorRequest }) => {
    const langQuery = getQueryLocale(getState());
    const language = langQuery ? `&language=${langQuery}` : '';

    const { tagCloud } = await aggregatorRequest(
      `/v1/tag-cloud-widget/render-model?onlyWithPublishedPosts=true${language}`,
      {
        throwOnInvalidJson: true,
      },
    );

    await dispatch(handleTagCloudWidgetResponse(tagCloud));
  };
